import { SocialType } from "shared/SocialsShare/SocialsShare";
import React, { FC } from "react";

export interface SocialsListProps {
  className?: string;
  itemClass?: string;
  socials?: SocialType[];
}

const socialsDemo: SocialType[] = [
  { name: "Facebook", icon: "lab la-facebook-square", href: "https://www.facebook.com/people/BCR-Ltd-Expansion-Joint-UK/100064174416066/" },
  { name: "Linkedn", icon: "lab la-linkedin-in", href: "https://www.linkedin.com/company/shadow-gap-profiles/" },
  { name: "Youtube", icon: "lab la-youtube", href: "https://www.youtube.com/channel/UC37h6R6_AODVk5hbxZ86-qQ" },
  { name: "Instagram", icon: "lab la-instagram", href: "https://www.instagram.com/bcr_profiles" },
];

const SocialsList: FC<SocialsListProps> = ({
  className = "",
  itemClass = "block",
  socials = socialsDemo,
}) => {
  return (
    <nav
      className={`nc-SocialsList flex space-x-2.5 text-2xl text-neutral-6000 dark:text-neutral-300 ${className}`}
      data-nc-id="SocialsList"
    >
      {socials.map((item, i) => (
        <a
          key={i}
          className={`${itemClass}`}
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          title={item.name}
        >
          <i className={item.icon}></i>
        </a>
      ))}
    </nav>
  );
};

export default SocialsList;
